var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.5,600c0,218.6,177.8,396.5,396.6,396.5c218.5,0,396.5-177.8,396.5-396.5S818.8,203.5,600.1,203.5 C381.4,203.5,203.5,381.4,203.5,600L203.5,600z M600,267.1c183.6,0,332.9,149.3,332.9,332.9S783.6,932.9,600.1,932.9 c-183.7,0-333-149.3-333-332.9S416.4,267.1,600,267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M598.6,857.6c22.3,0,40.3-18,40.3-40.3c0-22.2-18-40.3-40.3-40.3s-40.2,18-40.2,40.3S576.2,857.6,598.6,857.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.8,356.8h63.6v360h-63.6V356.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/Attention.e67c261370e9aa9d8ea3777e9788e9a9.svg";
export { ForwardRef as ReactComponent };